// Word-level matching between two wordings of the same voice-over text.
// The implementation lives in src/shared/wordMap.js (CommonJS), shared with
// the server-side task runner; this file only re-exports it for the browser.
import * as shared from '../shared/wordMap';

export const {
  bareOf, wordFace, normWord, textWords, alignedForms, matchWords, mapRange,
  turnPrefix, speakerOfPrefix, withSpeaker, fragmentFromSelection, wordAtSelection,
  fragmentDonorMap, fragmentTag, textTurns, turnAt,
} = shared;
